import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from "../../../../hooks/useTranslation";
import { Help } from "../../../../icons/index";
import { Button, Dialog, DialogActions, DialogButton, DialogContent, DialogTitle, makeStyles, Snackbar, Typography, } from "../../../../index";
var useStyles = makeStyles(function (theme) { return ({
    root: {
        width: 420,
    },
    button: {
        minWidth: 80,
        margin: theme.spacing(0.5, 0, -1.5),
        height: 40,
        borderRadius: theme.shape.borderRadius,
    },
    dialog: {
        maxWidth: 700,
    },
}); });
var SNACKBAR_POSITION = {
    vertical: 'bottom',
    horizontal: 'left',
};
var DISCLAIMER_TIMEOUT_MS = 10 * 1000;
/**
 * QrCodeが読み取れない場合がある旨を表示するコンポーネント。
 *
 * QrCodeReaderが開かれてから一定時間すると読み取れないと判定してメッセージを表示する。
 */
export var QrCodeReaderDisclaimer = function () {
    var _a = useState(false), disclaimerOpen = _a[0], setDisclaimerOpen = _a[1];
    var handleCloseDisclaimer = useCallback(function () { return setDisclaimerOpen(false); }, []);
    useEffect(function () {
        var timeout = setTimeout(function () { return setDisclaimerOpen(true); }, DISCLAIMER_TIMEOUT_MS);
        return function () { return clearTimeout(timeout); };
    }, []);
    var _b = useState(false), detailDialogOpen = _b[0], setDetailDialogOpen = _b[1];
    var handleOpenDetail = useCallback(function () { return setDetailDialogOpen(true); }, []);
    var handleCloseDetail = useCallback(function () { return setDetailDialogOpen(false); }, []);
    var classes = useStyles();
    var t = useTranslation().t;
    return (React.createElement(React.Fragment, null,
        React.createElement(Snackbar, { open: disclaimerOpen, className: classes.root, anchorOrigin: SNACKBAR_POSITION, message: t('タブレットを静かに動かしQRコードがきれいにうつるところまで近づけたり遠ざけたりします。'), action: React.createElement(React.Fragment, null,
                React.createElement(Button, { className: classes.button, variant: "text", dark: true, onClick: handleCloseDisclaimer },
                    React.createElement(Typography, null, t('閉じる'))),
                React.createElement(Button, { className: classes.button, variant: "text", dark: true, onClick: handleOpenDetail },
                    React.createElement(Help, null),
                    React.createElement(Typography, null, t('詳細')))) }),
        React.createElement(Dialog, { open: detailDialogOpen, className: classes.dialog },
            React.createElement(DialogTitle, null, t('詳細')),
            React.createElement(DialogContent, null,
                React.createElement(Typography, null, t('●ピントを合わせるには')),
                React.createElement(Typography, null, t('・タブレットを持ち、画面の真ん中にQRコードがおさまるようにしましょう。')),
                React.createElement(Typography, null, t('・タブレットを静かに動かしQRコードがきれいにうつるところまで近づけたり遠ざけたりしましょう。')),
                React.createElement("br", null),
                React.createElement(Typography, null, t('●読み取れない場合')),
                React.createElement(Typography, null, t('・QRコードを拡大して印刷した紙面を用意するか、ディスプレイに拡大して映したものを読み取るなどしてください。')),
                React.createElement(Typography, null, t('※QRコードの大きさによっては、カメラでうまく読み取れない場合があります。'))),
            React.createElement(DialogActions, null,
                React.createElement(DialogButton, { onClick: handleCloseDetail, fill: true }, t('OK'))))));
};
